import { getHeadings as r } from "@scalar/code-highlight/markdown";
import o from "github-slugger";
const s = (n, e) => n.map((t) => ({
  ...t,
  slug: e.slug(t.value)
}));
function i(n) {
  const e = new o(), t = r(n);
  return s(t, e);
}
const l = (n) => {
  const e = Math.min(...n.map((t) => t.depth));
  return e >= 1 && e <= 6 ? e : 1;
};
export {
  i as getHeadingsFromMarkdown,
  l as getLowestHeadingLevel
};
